import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocationStrategy, Location } from '@angular/common';

@Component({
  selector: 'app-multi-job-list',
  templateUrl: './multi-job-list.component.html',
  styleUrls: ['./multi-job-list.component.scss']
})
export class MultiJobListComponent implements OnInit {
  user = JSON.parse(localStorage.getItem('userRoles'))
  selectedTab
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private locationStrategy: LocationStrategy
  ) { }

  ngOnInit() {
    this.selectedTab = 0;
    this.route.queryParams.subscribe(params => {
      console.log("params in multi job list page", params);
      if (params.currentTab == 1) {
        this.updateQueryParams({ currentPage: 0, pageOption: 25 })
      }
      if (params.currentTab) {
        this.selectedTab = params.currentTab
        if (params.currentTab == 1)
          this.updateQueryParams({ currentPage: 0, pageOption: 25, currentTab: this.selectedTab })

        else this.updateQueryParams({ currentTab: this.selectedTab })
      }
      else {
        console.log("in else, updating query params")
        this.updateQueryParams({ currentTab: this.selectedTab })
      }
    });
  }

  tabChanged(event) {
    this.selectedTab = event.index
    if (this.selectedTab == 1) this.updateQueryParams({ currentPage: 0, pageOption: 25, currentTab: this.selectedTab })
    else this.updateQueryParams({ currentTab: this.selectedTab })
  }

  updateQueryParams(obj) {
    this._location.replaceState(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        {
          relativeTo: this.route, queryParams: obj
        },
      ).toString()
    );
    console.log("updated url: ", this.locationStrategy.path())
  }
}
